import * as React from "react";

import { Margins } from "@ui/Atoms";
import {
  BlockPageSkeleton,
  SidebarSkeleton as GenericSidebarSkeleton,
} from "@ui/Skeletons/Skeletons";

const PageSkeleton = React.memo(() => (
  <Margins xs={["base_x3", null, null, null]}>
    <div>
      <BlockPageSkeleton />
    </div>
  </Margins>
));

PageSkeleton.displayName = "PageSkeleton";

const SidebarSkeleton = React.memo(() => <GenericSidebarSkeleton />);
SidebarSkeleton.displayName = "SidebarSkeleton";

export { SidebarSkeleton, PageSkeleton };
